import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import styles from '../index.module.css';
import { getMarcoLegal } from '../../service/apiBackEnd'

const MarcoRegulatorio = () => {

  const [allData, setAllData] = useState([]);
  const [allMultas, setAllMultas] = useState([]);
  const [enrichedData, setEnrichedData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await getMarcoLegal();
      console.log("DATA", res);
      setAllData(res);
    };
    fetchData();
  }, []);

  console.log("DATAAAA", allData);

  return (
    <Container>

      <h1 className="mt-5 mb-4">Marco Legal</h1>
      <Row>
        <h3>Emergencia Hidrica</h3>
        {
          allData.map((item, index) => (
            <div key={index}>
              <div
                dangerouslySetInnerHTML={{
                  __html: item.acf?.emergencia_hidrica_provincial_decretos,
                }}
              />
              <hr />
            </div>
          ))
        }
      </Row>
      <Row>
        <h3>AYSAM SAPEM (Aguas Mendocinas)</h3>
        {
          allData.map((elem, index) => (
            <div>
              <h5>Contrato de Concesión (texto principal)</h5>
              {elem.acf.aysam_sapem_aguas_mendocinas_
                && (
                  <a href={elem.acf.aysam_sapem_aguas_mendocinas_}
                    style={{ width: "fit-content", marginBottom: "1em" }}
                    target="_blank" rel="noopener noreferrer"
                    download className={styles.btnDescarga}>
                    Descargar Archivo
                  </a>
                )}
              <h5>Decreto OSMSA</h5>
              {elem.acf.decreto_osmsa
                && (
                  <a href={elem.acf.decreto_osmsa}
                    style={{ width: "fit-content", marginBottom: "1em" }}
                    target="_blank" rel="noopener noreferrer"
                    download className={styles.btnDescarga}>
                    Descargar Archivo
                  </a>
                )}
            </div>
          ))
        }
      </Row>
    </Container>
  )
}

export default MarcoRegulatorio